import $ from "jquery";
import AjaxRequest from "../modules/ajax-request";

class Register {
    constructor(divSubscriptions, divForm, divRender) {
        this._divSubscriptions = divSubscriptions;
        this._divForm = divForm;
        this._divRender = divRender;
        this._renderActionUrl = this._divRender.data("render-action");
        this._formHtml = $(this._divForm).data("form-html");
        this._formAction = $(this._divForm).data("form-action");
        this._form = $(this._divForm).find('form');
        this._unmaskInput = $(this._divForm).find('[data-unmask-input]');
        this._emptyPaymentMessage = $(this._divForm).data("empty-payment");

        this.clearData();
        this.init();
        this.bindEvents();
    }
    clearData() {
        $(this._divForm).removeAttr("data-form-html");
        $(this._divForm).removeAttr("data-form-action");
    }
    init() {
        this.renderContent();
    }
    bindEvents() {
        var _thisRegister = this;
        $('body')
            .on("submit", '[name="register_form"]', function (event) {
                _thisRegister.formSubmit(event, $(this));
            })
            .on("click", '[data-id="mask"]', function (event) {
                _thisRegister.togglePasswordMask(event, this);
            })
            .on("click", '[data-id="unmask"]', function (event) {
                _thisRegister.togglePasswordMask(event, this);
            });
    }
    renderContent() {
        var _ulLinks = this._divRender;
        var isHome = _ulLinks.data('is-home');
        if (_ulLinks.length > 0) {
            var _ajaxRequest = new AjaxRequest({
                successCallback: function (response) {
                    if (response.renderContentHtml == true) {
                        window.location.replace("https://www.elfarmaceutico.es/perfil.html");
                    } else {
                        _ulLinks.html(response.renderContentHtml);
                    }
                }
            });

            _ajaxRequest.makeCall(this._renderActionUrl + '&isHome=' + isHome);
        }
    }
    togglePasswordMask(event, element) {
        event.preventDefault();
        $(element).toggleClass("is-active");
        var _unmaskInput = $('[data-unmask-input]');
        if (_unmaskInput.attr("type") === "password") {
            _unmaskInput.attr("type", "text");
            $('[data-id="mask"]').hide();
            $('[data-id="unmask"]').show();
        } else {
            _unmaskInput.attr("type", "password");
            $('[data-id="mask"]').show();
            $('[data-id="unmask"]').hide();
        }
    }
    formSubmit(event, form) {
        event.preventDefault();

        var _divMessage = $('[data-form-message]');
        $(_divMessage).html("");
        $(_divMessage).removeClass("is-success");
        $(_divMessage).removeClass("is-failure");

        var ajaxRequest = "";

        ajaxRequest = new AjaxRequest({
            successCallback: function (data) {
                form.removeClass("is-loading");
                $(_divMessage).html(data.message);
                $(_divMessage).addClass("is-success");
                $('[name="register_form"]').hide();

            },
            errorCallback: function (data) {
                form.removeClass("is-loading");
                $(_divMessage).html(data.responseJSON.message);
                $(_divMessage).addClass("is-failure");
            }
        });

        form.addClass("is-loading");
        $(_divMessage).html("");
        $(_divMessage).removeClass("is-success");
        $(_divMessage).removeClass("is-failure");

        ajaxRequest.makeCall(form.attr('action'), form.serializeArray());
    }
}

export default Register;
